<template>
  <div>
    <div v-if="!readOnly" class="op">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form class="b-layout" @submit.prevent="">
      <div v-if="operationSelected" class="varieables">
        <div class="inp">
          <label>{{ $t('taxa-de-reciclo') }}</label>
          <input
            v-model="xb.value"
            type="number"
            step="0.02"
            min="0"
            max="100"
            @change="updateNode"
          />
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { SingletonInter } from '../_service/singletonInter';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      xb: {},
      operations: [
        { value: null, text:SingletonInter.$t('selecione-coluna-destilacao-a') + ": "  },
      ],
      operationSelected: null,
      operationAttributeList: [],
      attributesList: SingletonInter.$t('selecione-coluna-destilacao-a') + ": ",
      firstLoad: false,
      attrList: ["xb"],
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.xb = this.operationAttributeList.find(
        (p) => this.attrList[0] == p.caption
      );
      if (this.xb) this.xb.value = ParseToNumber(this.xb.value);
      this.updateNode();
    },

    "xb.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
      }

      this.node.data.forEach((p) => {
        this.attrList.forEach((a) => {
          if (p.caption == a) {
            p.value = ParseToNumber(p.value);
            this[a] = p;
          }
        });
      });
    },

    updateNode() {
      this.node.attrs = [this.xb.clone()];
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/ColunaDestilacaoA/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();

    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.op {
  margin: 2%;
}
</style>